export const BASE_URL =
  "https://service-dbdvs8e6-1302190278.usw.apigw.tencentcs.com/release";

// export const BASE_URL = "http://localhost:9000";
